<template>
  <v-container>
    <form v-on:keyup.enter="submit" class="pa-4">
      <v-card flat outlined class="ma-4">
        <v-toolbar flat color="primary white--text">
          <v-toolbar-title>Update Profil Pengurus</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            outlined
            label="Nama"
            v-model.trim="$v.profileForm.full_name.$model"
            :error-messages="nameError"
          >
          </v-text-field>
          <v-text-field
            outlined
            label="Email"
            v-model.trim="$v.profileForm.email.$model"
            :error-messages="emailError"
          >
          </v-text-field>
          <v-text-field
            outlined
            label="Username"
            v-model.trim="$v.profileForm.username.$model"
            :error-messages="usernameError"
          >
          </v-text-field>
          <v-btn color="primary" @click="submit">Update</v-btn>
        </v-card-text>
      </v-card>
    </form>

    <p v-if="isFormError" class="mt-2 red--text text-caption error-caption">
      "Manusia memang sering melakukan kesalahan, tapi yang terpenting adalah
      bagaimana kita memperbaikinya" <br />
      -Admin
    </p>
  </v-container>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import router from "../router";

export default {
  data() {
    return {
      profileForm: {
        full_name: "",
        email: "",
        username: "",
      },
      userDetail: {},
      isFormError: false,
    };
  },
  validations: {
    profileForm: {
      full_name: {
        required,
        minLength: minLength(6),
      },
      email: {
        required,
        email,
      },
      username: {
        required,
        minLength: minLength(6),
      },
    },
  },
  computed: {
    userDetails() {
      return this.userDetail;
    },
    nameError() {
      const errors = [];
      if (!this.$v.profileForm.full_name.$dirty) return errors;
      !this.$v.profileForm.full_name.minLength &&
        errors.push("Nama minimal 6 huruf");
      !this.$v.profileForm.full_name.required &&
        errors.push("Nama tidak boleh kosong");
      return errors;
    },
    emailError() {
      const errors = [];
      if (!this.$v.profileForm.email.$dirty) return errors;
      !this.$v.profileForm.email.email &&
        errors.push("Email tidak sesuai format");
      !this.$v.profileForm.email.required &&
        errors.push("Email tidak boleh kosong");
      return errors;
    },
    usernameError() {
      const errors = [];
      if (!this.$v.profileForm.username.$dirty) return errors;
      !this.$v.profileForm.username.minLength &&
        errors.push("Username minimal 6 huruf");
      !this.$v.profileForm.username.required &&
        errors.push("Username tidak boleh ksosong");
      return errors;
    },
  },
  watch: {
    userDetails() {
      this.profileForm.full_name = this.userDetails.full_name;
      this.profileForm.email = this.userDetails.email;
      this.profileForm.username = this.userDetails.username;
    },
  },
  created() {
    this.axios("/meta_")
      .then((response) => {
        console.log(response.data, "res user meta");
        if (response.data !== null) {
          this.userDetail = response.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    submit: function () {
      this.$v.$touch();
      if (this.$v.profileForm.$invalid) {
        this.isFormError = true;
      } else {
        console.log(this.profileForm);
        router.push("/admin/profile");
      }
    },
  },
};
</script>

<style>
</style>